import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=f95f427e&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=f95f427e&prod&lang=css"
import style1 from "./ProductList.vue?vue&type=style&index=1&id=f95f427e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95f427e",
  null
  
)

export default component.exports